<app-dialog-header cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  [titleTranslateKey]="'scheduler.booking.history.title'"
  [showAuditButton]="allowAudit"
  (auditClicked)="openVisitAudit()"
  (closeClicked)="dialogRef.close()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">
  <div class="grid-container">
    <app-grid (gridEvents)="onEvent($event)" [columns]="columns" [filter]="true" [showContextMenu]="true"
      [showDirty]="true" [showRemoveRowInContextMenu]="true" [store]="gridStore"
      [width]="'100%'"></app-grid>
  </div>
  <mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
    [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
    hidePageSize="false" showFirstLastButtons="true">
  </mat-paginator>
</mat-dialog-content>
